import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=124b74f9"
import script from "./DialogComponent.vue?vue&type=script&lang=js"
export * from "./DialogComponent.vue?vue&type=script&lang=js"
import style0 from "./DialogComponent.vue?vue&type=style&index=0&id=124b74f9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports